var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-cabinet-verification-profile-general"},[_c('ui-form',{attrs:{"model":_vm.fields,"validation":_vm.$v,"submit-handler":_vm.submit},on:{"update":_vm.updateFormData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }